export default __webpack_public_path__ + "static/media/8054c7c6c4c49a8da7d6bacfcc9f92591600804999465.1fbefda2.webp";